var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthorize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "0 -960 960 960",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-71.63q-142.532-35.672-235.331-162.562-92.8-126.89-92.8-281.808v-249.61L480-888.37l328.131 122.76V-516q0 154.918-92.8 281.808Q622.532-107.302 480-71.63Zm0-95q102.326-34.435 169.728-132 67.402-97.566 67.402-217.259v-186.959L480-791.652l-237.13 88.92V-516q0 119.804 67.402 217.37 67.402 97.565 169.728 132Zm0-312.892Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorize);
export default __webpack_public_path__ + "static/media/authorize.9a5abe1c3128a52bc9490b3852636b25.svg";
export { ForwardRef as ReactComponent };